module.exports = __webpack_public_path__ + "static/media/20.9f1ac9d6.jpg";